/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeSubsystemComponentClassComponentTypeResponseDto
 */
export interface AssetTypeSubsystemComponentClassComponentTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    assetTypeSubsystemComponentClassId: string;
    /**
     * Code of the subsystem
     * @type {string}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    subsystemCode: string;
    /**
     * Code of the asset type
     * @type {string}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    assetTypeCode: string;
    /**
     * Code of the component class
     * @type {string}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    componentClassCode: string;
    /**
     * Array of associated component-type IDs
     * @type {Array<string>}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    associatedComponentTypeIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemComponentClassComponentTypeResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetTypeSubsystemComponentClassComponentTypeResponseDto interface.
 */
export function instanceOfAssetTypeSubsystemComponentClassComponentTypeResponseDto(value: object): value is AssetTypeSubsystemComponentClassComponentTypeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeSubsystemComponentClassId' in value) || value['assetTypeSubsystemComponentClassId'] === undefined) return false;
    if (!('subsystemCode' in value) || value['subsystemCode'] === undefined) return false;
    if (!('assetTypeCode' in value) || value['assetTypeCode'] === undefined) return false;
    if (!('componentClassCode' in value) || value['componentClassCode'] === undefined) return false;
    if (!('associatedComponentTypeIds' in value) || value['associatedComponentTypeIds'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetTypeSubsystemComponentClassComponentTypeResponseDtoFromJSON(json: any): AssetTypeSubsystemComponentClassComponentTypeResponseDto {
    return AssetTypeSubsystemComponentClassComponentTypeResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeSubsystemComponentClassComponentTypeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeSubsystemComponentClassComponentTypeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeSubsystemComponentClassId': json['assetTypeSubsystemComponentClassId'],
        'subsystemCode': json['subsystemCode'],
        'assetTypeCode': json['assetTypeCode'],
        'componentClassCode': json['componentClassCode'],
        'associatedComponentTypeIds': json['associatedComponentTypeIds'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetTypeSubsystemComponentClassComponentTypeResponseDtoToJSON(json: any): AssetTypeSubsystemComponentClassComponentTypeResponseDto {
    return AssetTypeSubsystemComponentClassComponentTypeResponseDtoToJSONTyped(json, false);
}

export function AssetTypeSubsystemComponentClassComponentTypeResponseDtoToJSONTyped(value?: AssetTypeSubsystemComponentClassComponentTypeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeSubsystemComponentClassId': value['assetTypeSubsystemComponentClassId'],
        'subsystemCode': value['subsystemCode'],
        'assetTypeCode': value['assetTypeCode'],
        'componentClassCode': value['componentClassCode'],
        'associatedComponentTypeIds': value['associatedComponentTypeIds'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

